"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeStyles = mergeStyles;
function mergeStyles() {
  var basestyles = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var overrides = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var ret = {};
  Object.keys(basestyles).forEach(function (key) {
    ret[key] = Object.assign({}, basestyles[key], overrides[key]);
  });
  return ret;
}


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/tools.js
 **/